<div class="border border-radius-2">
    <div class="row bg-primary m-auto">
        <div class="col-12 col-md-6">
            <div class="btn-group">
                <div class="btn btn-primary border-radius-0" mwlCalendarPreviousView [view]="view"
                    [(viewDate)]="viewDate">
                    Previous
                </div>
                <div class="btn bg-white border-radius-0" mwlCalendarToday [(viewDate)]="viewDate">
                    Today
                </div>
                <div class="btn btn-primary border-radius-0" mwlCalendarNextView [view]="view" [(viewDate)]="viewDate">
                    Next
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 text-end">
            <div class="btn-group">
                <div class="btn btn-primary border-radius-0" (click)="setView(CalendarView.Month)"
                    [class.active]="view === CalendarView.Month">
                    Month
                </div>
                <div class="btn btn-primary border-radius-0" (click)="setView(CalendarView.Week)"
                    [class.active]="view === CalendarView.Week">
                    Week
                </div>
                <div class="btn btn-primary border-radius-0" (click)="setView(CalendarView.Day)"
                    [class.active]="view === CalendarView.Day">
                    Day
                </div>
            </div>
        </div>
    </div>
    <div [ngSwitch]="view">

        <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events">
        </mwl-calendar-month-view>

        <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events">
        </mwl-calendar-week-view>

        <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="events">
        </mwl-calendar-day-view>

    </div>
</div>
